module.exports = "data:text/xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPGJyb3dzZXJjb25maWc+CiAgICA8bXNhcHBsaWNhdGlvbj4KICAgICAgICA8dGlsZT4KICAgICAgICAgICAgPHNxdWFyZTE1MHgxNTBsb2dvIHNyYz0iL3VwbG9hZHMvaWNvbnMvbXN0aWxlLTE1MHgxNTAucG5nIi8+CiAgICAgICAgICAgIDxUaWxlQ29sb3I+IzgwOTNkOTwvVGlsZUNvbG9yPgogICAgICAgIDwvdGlsZT4KICAgIDwvbXNhcHBsaWNhdGlvbj4KPC9icm93c2VyY29uZmlnPgo="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/public/uploads/icons/browserconfig.xml
// module id = 194
// module chunks = 0 1 2